import { CheckCircleOutlined, CheckOutlined, CheckSquareTwoTone, ClockCircleOutlined, CloseOutlined, EditOutlined, EnvironmentOutlined, MobileOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarAsistencia from "./AgregarAsistencia/AgregarAsistencia";
import EditarAsistencia from "./EditarAsistencia/EditarAsistencia";
import ModalUbicacionAsistencia from "./ModalUbicacionAsistencia/ModalUbicacionAsistencia";

moment.locale("es");

class Asistencia extends Component {
    tableRef = null;
    state = {
        todasAsistencias: [],
        loading: false,
        valor: 1,
        modalAgregarAsistencia: false,
        modalEditarAsistencia: false,
        modalEditarAsistenciaId: null,
        modalUbicacionAsistencia: false,
        modalUbicacionAsistenciaId: null,
    };
    consultarAsistencias(params) {
        this.setState({ loading: true });
        axios
            .post(
                "asistencias/selectTodasAsistencias",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasAsistencias: [] });
                } else {
                    this.setState({
                        todasAsistencias: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarAsistencia(value) {
        this.setState({ loading: true });
        axios
            .post(
                "asistencias/deshabilitarAsistencia",
                { asistenciaId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Asistencia deshabilitada");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarAsistencia(value) {
        this.setState({ loading: true });
        axios
            .post(
                "asistencias/habilitarAsistencia",
                { asistenciaId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Asistencia habilitada");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    revisarAsistencia(asistenciaId, aprobar) {
        this.setState({ loading: true });
        axios
            .post(
                "asistencias/revisarAsistencia",
                { asistenciaId, aprobar, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success(aprobar ? "Asistencia aprobada" : "Asistencia rechazada");
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se pudo revisar la asistencia");
                } else {
                    message.error("Sucedio un error y no se pudo revisar la asistencia");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    verUbicacionAsistencia(id) {
        this.setState({ modalUbicacionAsistencia: true, modalUbicacionAsistenciaId: id });
    }
    cerrarUbicacionAsistencia() {
        this.setState({ modalUbicacionAsistencia: false });
    }

    // Los registros anteriores a la checada remota no traen origen
    origenAsistencia(record) {
        return record.origen || (record.automatico ? "reloj" : "manual");
    }

    agregarAsistencia() {
        this.setState({ modalAgregarAsistencia: true });
    }
    cerrarAgregarAsistencia() {
        this.setState({ modalAgregarAsistencia: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    editarAsistencia(id) {
        this.setState({ modalEditarAsistencia: true, modalEditarAsistenciaId: id });
    }
    cerrarEditarAsistencia() {
        this.setState({ modalEditarAsistencia: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    statusEntrada(entrada) {
        switch (entrada) {
            case 0:
                return "Entrada";
            case 1:
                return "Salida";
            case 2:
                return "Entrada a descanso";
            case 3:
                return "Salida de descanso";
            case 4:
                return "Entrada de T.E.";
            case 5:
                return "Salida de T.E.";
            default:
                return "Desconocido";
        }
    }

    colorStatusEntrada(entrada) {
        switch (entrada) {
            case 0:
                return "#1677ff";
            case 1:
                return "#fa541c";
            case 2:
                return "#69a7ff";
            case 3:
                return "#ff8c66";
            case 4:
                return "#69a7ff";
            case 5:
                return "#ff8c66";
            default:
                return "#000000";
        }
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value,record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Número Empleado",
                dataIndex: "empleadoSerieNumero",
                key: "empleadoSerieNumero",
                width: "6%",
            },
            {
                title: "Empleado",
                dataIndex: "empleadoNombre",
                key: "empleadoNombre",
                buscar: "empleadoNombre",
                width: "18%",
            },
            {
                title: "Reloj Checador",
                dataIndex: "relojChecadorNombre",
                key: "relojChecadorNombre",
                buscar: "relojChecadorNombre",
                width: "18%",
            },
            {
                title: "Origen",
                dataIndex: "origen",
                key: "origen",
                align: "center",
                width: "7%",
                render: (value, record) => {
                    const origen = this.origenAsistencia(record);
                    return (
                        <div style={{ textAlign: "center" }}>
                            {origen === "app" && <Tooltip title="App móvil"><MobileOutlined style={{ fontSize: 18, color: "#00BFD6" }} /></Tooltip>}
                            {origen === "reloj" && <Tooltip title="Reloj checador"><ClockCircleOutlined style={{ fontSize: 18, color: "#1677ff" }} /></Tooltip>}
                            {origen === "manual" && <Tooltip title="Captura manual"><EditOutlined style={{ fontSize: 18, color: "#888" }} /></Tooltip>}
                            {record.offline && (
                                <div><Tag color="purple" style={{ marginTop: 4, marginRight: 0 }}>Offline</Tag></div>
                            )}
                        </div>
                    );
                },
            },
            {
                title: "Rostro",
                dataIndex: "verificacionRostro",
                key: "verificacionRostro",
                align: "center",
                width: "6%",
                render: (value) => {
                    if (!Number.isFinite(value?.puntaje)) return "—";
                    const porcentaje = Math.round(value.puntaje * 100);
                    const minimo = Number.isFinite(value?.umbral) ? Math.round(value.umbral * 100) : null;
                    return (
                        <Tooltip title={minimo != null ? `Mínimo requerido: ${minimo}%` : "Parecido con la fotografía registrada"}>
                            <Tag color={minimo != null && porcentaje < minimo ? "red" : "green"}>{porcentaje}%</Tag>
                        </Tooltip>
                    );
                },
            },
            {
                title: "Proyecto",
                dataIndex: "proyectoNombre",
                key: "proyectoNombre",
                buscar: "proyectoNombre",
                width: "18%",
            },
            {
                title: "Automatico",
                dataIndex: "automatico",
                key: "automatico",
                render: (value) => {
                    if (value) {
                        return <CheckSquareTwoTone twoToneColor={["rgb(131, 204, 22)", "#ffffff00"]} style={{ fontSize: 20 }} />;
                    }
                    return null;
                },
                align: 'center',
                width: "7%",
            },
            {
                title: "Asistencia",
                dataIndex: "fechaAsistencia",
                key: "fechaAsistencia",
                width: "12%",
                align: "center",
                render: (_, record) => {
                    const fechaHora = moment(record.fechaAsistencia).format("DD/MM/YYYY HH:mm");
                    const estadoEntrada = this.statusEntrada(record.entrada);

                    return (
                        <div style={{ textAlign: "center" }}>
                            <div
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: this.colorStatusEntrada(record.entrada),
                                }}
                            >
                                {estadoEntrada}
                            </div>

                            <div style={{ fontSize: "12px", color: "#666" }}>
                                {fechaHora}
                            </div>
                        </div>
                    );
                },
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value, record) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    if (value === 3) {
                        return (
                            <Tooltip title={record.motivoRevision}>
                                <Tag color="gold">Pendiente de revisión</Tag>
                            </Tooltip>
                        );
                    }
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (!record.automatico && this.props.permisoEditarAsistencia) {
                        buttons.push(
                            <Tooltip
                                title="Editar Asistencia"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    key={`editar-${record._id}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarAsistencia(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (this.origenAsistencia(record) === "app") {
                        buttons.push(
                            <Tooltip
                                key={`ubicacion-${record._id}`}
                                title="Ver ubicación"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    azul
                                    icon={<EnvironmentOutlined />}
                                    onClick={() => this.verUbicacionAsistencia(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    // Una checada pendiente de revisión solo se aprueba o se rechaza, no se habilita directo
                    if (this.props.permisoDeshabilitarAsistencia && record.estado === 3) {
                        buttons.push(
                            <Popconfirm
                                key={`aprobar-${record._id}`}
                                title="¿Aprobar esta checada? Contará en los reportes de asistencia."
                                onConfirm={() => this.revisarAsistencia(record._id, true)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip
                                    title="Aprobar"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        verdeNatural
                                        icon={<CheckOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                        buttons.push(
                            <Popconfirm
                                key={`rechazar-${record._id}`}
                                title="¿Rechazar esta checada? No contará en los reportes de asistencia."
                                onConfirm={() => this.revisarAsistencia(record._id, false)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <Tooltip
                                    title="Rechazar"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<CloseOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else if (this.props.permisoDeshabilitarAsistencia) {
                        if (record.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    key={`deshabilitar-${record._id}`}
                                    title="¿Seguro que quieres deshabilitar esta asistencia?"
                                    onConfirm={() => this.deshabilitarAsistencia(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Deshabilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${record._id}`}
                                    title="¿Seguro que quieres habilitar esta asistencia?"
                                    onConfirm={() => this.habilitarAsistencia(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Habilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Asistencias"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }, { label: 'Pendientes de revisión', value: 4 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            {this.props.permisoAgregarAsistencia && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarAsistencia"
                                    onClick={this.agregarAsistencia.bind(this)}
                                >
                                    Agregar Asistencia
                                </ButtonItem>
                            )}
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarAsistencias.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasAsistencias}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"asistencias" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarAsistencia) {
                                this.editarAsistencia(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                <AgregarAsistencia
                    visible={this.state.modalAgregarAsistencia}
                    cerrarAgregarAsistencia={this.cerrarAgregarAsistencia.bind(this)}
                />
                <EditarAsistencia
                    visible={this.state.modalEditarAsistencia}
                    asistenciaId={this.state.modalEditarAsistenciaId}
                    cerrarEditarAsistencia={this.cerrarEditarAsistencia.bind(this)}
                />
                <ModalUbicacionAsistencia
                    visible={this.state.modalUbicacionAsistencia}
                    asistenciaId={this.state.modalUbicacionAsistenciaId}
                    cerrarUbicacionAsistencia={this.cerrarUbicacionAsistencia.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarAsistencia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020e37899dda241377ce8")?.activado,
        permisoEditarAsistencia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020f17899dda241377ce9")?.activado,
        permisoDeshabilitarAsistencia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021007899dda241377cea")?.activado,
    };
};

export default connect(mapStateToProps)(Asistencia);
